<div class="d-flex justify-content-center">
    <div class="row g-3 align-items-center">
        <div class="col-auto">
            <div class="btn-group" role="group" aria-label="Basic outlined example">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="confirmarOpcion('PDF');"><i
                        class="bi bi-filetype-pdf"></i>
                    Pdf</button>
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="confirmarOpcion('EXCELOPENXML');"><i
                        class="bi bi-file-earmark-spreadsheet"></i> Excel</button>
                <button type="button" ngbAutofocus class="btn btn-outline-secondary btn-sm me-1" (click)="cancelar();">
                    <i class="bi bi-x-lg"></i> Cancelar
                </button>
            </div>
        </div>
    </div>
</div>